var _g, _rect, _path, _path2, _circle, _circle2, _circle3, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "52.5 74 174 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 134,
    r: 60,
    fill: "#60B70A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 134,
    r: 59.5,
    stroke: "#E8FFD0"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.9,
    y: 143.4,
    width: 7.2,
    height: 7.2,
    rx: 1.6,
    stroke: "#38C5F2",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.355 90.7481L203.426 85.1697L204.721 94.0827L196.355 90.7481Z",
    stroke: "#EF24DB",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.152 186.543L188.223 180.965L189.518 189.878L181.152 186.543Z",
    stroke: "#73B024",
    strokeWidth: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 134.5,
    r: 4.1,
    stroke: "#DAC507",
    strokeWidth: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 89,
    cy: 204.5,
    r: 4.1,
    stroke: "#37B7FF",
    strokeWidth: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 90.5,
    r: 4.1,
    stroke: "#FF9F2E",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.392 106.003C118.645 105.79 105.79 118.645 106.003 134.392C106.213 149.493 118.509 161.79 133.611 162C149.36 162.215 162.213 149.36 161.997 133.614C161.79 118.509 149.493 106.213 134.392 106.003ZM132.132 131.911L139.071 123.969C139.447 123.539 139.978 123.275 140.548 123.237C141.118 123.199 141.68 123.388 142.11 123.764C142.54 124.14 142.804 124.672 142.842 125.242C142.88 125.812 142.691 126.374 142.315 126.804L135.376 134.746C135.19 134.959 134.963 135.133 134.71 135.259C134.456 135.384 134.181 135.458 133.898 135.477C133.616 135.496 133.333 135.46 133.065 135.369C132.797 135.279 132.549 135.136 132.336 134.95C132.123 134.764 131.949 134.538 131.823 134.284C131.698 134.031 131.623 133.755 131.604 133.473C131.585 133.191 131.622 132.907 131.713 132.639C131.803 132.371 131.945 132.124 132.132 131.911ZM126.901 144.14C126.497 144.544 125.949 144.77 125.378 144.77C124.807 144.77 124.26 144.544 123.856 144.14L117.401 137.679C117.201 137.479 117.043 137.241 116.935 136.98C116.827 136.718 116.771 136.438 116.771 136.155C116.771 135.873 116.827 135.593 116.935 135.331C117.044 135.07 117.203 134.833 117.403 134.633C117.603 134.433 117.84 134.274 118.102 134.166C118.363 134.058 118.643 134.002 118.926 134.002C119.209 134.003 119.489 134.058 119.75 134.167C120.012 134.275 120.249 134.434 120.449 134.634L126.91 141.095C127.312 141.5 127.537 142.049 127.536 142.62C127.534 143.191 127.306 143.737 126.901 144.14ZM150.7 126.804L135.64 144.034C135.445 144.256 135.208 144.436 134.941 144.563C134.675 144.689 134.385 144.76 134.09 144.77H134.017C133.734 144.77 133.454 144.714 133.193 144.606C132.931 144.498 132.694 144.339 132.494 144.139L126.041 137.677C125.637 137.273 125.41 136.725 125.41 136.154C125.411 135.583 125.638 135.035 126.042 134.631C126.446 134.228 126.994 134.001 127.565 134.001C128.137 134.001 128.684 134.229 129.088 134.633L133.099 138.648C133.204 138.752 133.328 138.834 133.465 138.888C133.603 138.942 133.75 138.968 133.897 138.963C134.044 138.958 134.189 138.923 134.322 138.86C134.456 138.796 134.575 138.707 134.672 138.596L147.46 123.969C147.835 123.539 148.367 123.275 148.937 123.237C149.507 123.199 150.069 123.388 150.499 123.764C150.929 124.14 151.192 124.672 151.231 125.242C151.269 125.812 151.08 126.374 150.704 126.804H150.7Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2505_8278",
    x: 0,
    y: 0,
    width: 280,
    height: 280,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.580392 0 0 0 0 0.85098 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2505_8278"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2505_8278",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess1);
export default __webpack_public_path__ + "static/media/success-1.e3e8a26c6d1701274d84ef15d3718ff7.svg";
export { ForwardRef as ReactComponent };